import { Button, Space } from "antd";
import { useEffect, useState } from "react";
import DownloadIcon from "../../../../assets/icons/DownloadIcon";
import UploadExcelModal from "../../../../components/common/UploadExcelModal";
import { EMP_API } from "../../../../constants/apiUrl";
import { APP_API } from "../../../../constants/constants";
import {
  EmployeeData,
  GetEmployeeParamsType,
} from "../../../../features/emp-setting/employee/employee.type";
import { useUploadEmployeeBkashDataMutation } from "../../../../features/emp-setting/employee/employeeApi";
import useDownloadEmployeeXlsx from "../../../../hooks/useDownloadExcelWithApi";
import useError from "../../../../hooks/useError";
import { toast } from "../../../../lib/toast";
import { ModalComponentProps } from "../../../../types";

interface BKashNumberModalParams extends ModalComponentProps {
  employeeParams: GetEmployeeParamsType;
}

export default function BKashNumberModal({
  open,
  handleClose,
  employeeParams,
}: BKashNumberModalParams) {
  const { loading: excelLoading, downloadXlsx } = useDownloadEmployeeXlsx();
  const [uploadEmployeeData, { isLoading, isError, error, isSuccess }] =
    useUploadEmployeeBkashDataMutation();
  useError(isError, error, "Upload bKash data fail");
  const [formData, setFormData] = useState<FormData | null>(null);

  const handleDownload = () => {
    downloadXlsx(
      APP_API + EMP_API.getEmployees,
      { ...employeeParams, skip: 0, limit: 0 },
      "Coworker_Bkash_Number",
      "employees",
      (employee: EmployeeData) => {
        return {
          "Employee Name": employee?.member?.profile?.name ?? "-",
          "Employee Email": employee?.member?.profile?.email ?? "-",
          "bKash Number": employee?.bkash_info?.account_no ?? "-",
        };
      }
    );
  };

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "bKash number updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess]);

  return (
    <UploadExcelModal
      open={open}
      handleClose={handleClose}
      isLoading={false}
      handler={setFormData}
      title="Update bKash Number Data in Bulk"
      warningText="First download the active Employee informations and upload it after editing desired informations."
      downloadLink={"/Coworker_Bkash_Number_Sample.xls"}
      footer={
        <Space size={12}>
          <Button
            className="outline-button-primary modal-button"
            icon={<DownloadIcon />}
            loading={excelLoading}
            onClick={handleDownload}
          >
            Download Existing Data
          </Button>
          <Button
            className="modal-button"
            type="primary"
            loading={isLoading}
            onClick={() => uploadEmployeeData(formData)}
          >
            Upload
          </Button>
        </Space>
      }
    />
  );
}
